import styled from 'styled-components'

export const ContainerBabi = styled.div`
  border-color: var(--gray100);
`
